import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: ${(p) => p.theme.spacing(1)};
`;
